const DEPENDENCIES = [
  { name: 'authentication', url: 'https://cpaas-assets-hlg.lan.zenvia360.com/auth/index.js' },
  { name: 'eventbus', url: 'https://cpaas-assets-hlg.lan.zenvia360.com/eventbus/index.js' },
  { name: 'feature-toggle', url: 'https://cpaas-assets-hlg.lan.zenvia360.com/feature-toggle/index.js' },
  { name: 'selfservice', url: 'https://app-dsv.lan.zenvia360.com/selfservice/main-es5.js' },
  { name: 'notifications', url: 'https://cpaas-assets-hlg.lan.zenvia360.com/notifications/app.js' },
  { name: 'navbar-v2', url: 'https://app-dsv.lan.zenvia360.com/navbar-v2/app.js' },
  { name: 'components', url: 'https://app-dsv.lan.zenvia360.com/components/js/app.js' },
  { name: 'channel-sms', url: 'https://app-dsv.lan.zenvia360.com/channel-sms/app.js' },
  { name: 'channel-messenger', url: 'https://app-dsv.lan.zenvia360.com/channel-messenger/app.js' },
  { name: 'channel-voice', url: 'https://app-dsv.lan.zenvia360.com/channel-voice/app.js' },
  { name: 'channel-whatsapp', url: 'https://app-dsv.lan.zenvia360.com/channel-whatsapp/app.js' },
  { name: 'channel-webchat', url: 'https://app-dsv.lan.zenvia360.com/channel-webchat/app.js' },
  { name: 'channel-rcs', url: 'https://app-dsv.lan.zenvia360.com/channel-rcs/app.js' },
  { name: 'home', url: 'https://app-dsv.lan.zenvia360.com/cpaas-home/app.js' },
  { name: 'customer-area', url: 'https://customer-area-hlg.lan.zenvia360.com/app.js' },
  { name: 'flows', url: 'https://cpaas-assets-dev.lan.zenvia360.com/flows/main-es5.js' },
  { name: 'organizations', url: 'https://cpaas-assets-hlg.lan.zenvia360.com/platform-organizations/app.js' },
  { name: 'campaign-sidebar', url: 'https://app-dsv.lan.zenvia360.com/campaign-sidebar/app.js' },
  { name: 'contacts', url: 'https://app-dsv.lan.zenvia360.com/contacts/app.js' },
  { name: 'campaign-automation', url: 'https://app-dsv.lan.zenvia360.com/campaign-automation/app.js' },
  { name: 'campaign-dispatches', url: 'https://app-dsv.lan.zenvia360.com/campaign-dispatches/app.js' },
  { name: 'builder', url: 'https://app-dsv.lan.zenvia360.com/builder/app.js' },
  { name: 'broadcast', url: 'https://app-dsv.lan.zenvia360.com/platform-broadcast/app.js' },
  { name: 'channel-instagram', url: 'https://app-dsv.lan.zenvia360.com/channel-instagram/app.js' },
  { name: 'platform-report', url: 'https://cpaas-assets-hlg.lan.zenvia360.com/platform-report/app.js' },
  { name: 'labs', url: 'https://cpaas-assets-hlg.lan.zenvia360.com/zlabs-showcase/platform-labs.js' },
  { name: 'platform-errors-page', url: 'https://cpaas-assets-hlg.lan.zenvia360.com/platform-errors-page/app.js' },
  { name: 'home-v2', url: 'https://app-dsv.lan.zenvia360.com/home-v2/app.js' },
  { name: 'feedback-service', url: 'https://cpaas-assets-hlg.lan.zenvia360.com/feedback-service/index.js' },
  { name: 'channel-v2', url: 'https://app-dsv.lan.zenvia360.com/channel-v2/app.js' },
  { name: 'customer-data-service', url: 'https://cpaas-assets-hlg.lan.zenvia360.com/customer-data-service/index.js' },
]

const LOGS_URL = 'https://logs-api-hlg.zenvia.com'
const CUSTOM_PLATFORM_URL = 'https://custom-platform-hlg.zenvia.com'
const WEB_COMPONENTS_URL = 'https://cpaas-assets-hlg.lan.zenvia360.com/platform-web-components/platform-web-components.js'
const WEB_CHAT = 'https://static.zenvia.com/embed/js/zenvia-chat.hlg.min.js'

export default {
  DEPENDENCIES,
  LOGS_URL,
  CUSTOM_PLATFORM_URL,
  WEB_COMPONENTS_URL,
  WEB_CHAT,
}
